module.exports = __webpack_public_path__ + "static/media/usd-square.de60b6e3.svg";